import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizOverlayActive: false, // true when quiz overlay is shown
  quizComponentActive: false, // true when quiz component is shown
  autoLogoutActive: false,
  // other quiz states...
};

const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    setQuizOverlayActive: (state, action) => {
      state.quizOverlayActive = action.payload;
    },
    setQuizComponentActive: (state, action) => {
      state.quizComponentActive = action.payload;
    },
    setAutoLogoutActive: (state, action) => {
      state.autoLogoutActive = action.payload;
    },
    // other actions...
  },
});

export const {
  setQuizOverlayActive,
  setQuizComponentActive,
  setAutoLogoutActive,
} = quizSlice.actions;

export default quizSlice.reducer;
